export const CropConstants = {
  SUNFLOWER_CROP_ID: 2,
  CORN_CROP_ID: 1,
  SILAGE_CORN_CROP_ID: 3,
  SUMMER_CORN_CROP_ID: 6,
  BARLEY_CROP_ID: 4,
  CORN_SMALLCASE: 'corn',
  WINTER_OILSEED_RAPE: 'Winter Oilseed Rape',
  HYBRID_BARLEY: 'Hybrid Barley',
  WOSR: 'WOSR',
  BARLEY: 'barley',
  SUMMER_CORN_SMALLCASE: 'summer corn',
  SUNFLOWER_SMALLCASE: 'sunflower',
  SILAGE_CORN_SMALLCASE: 'silage corn',
  NO_TILLAGE: 'No Tillage',
  MINIMAL_TILLAGE: 'Minimal Tillage',
  SUNFLOWER_BAG_CAPACITY: 150000,
  CORN_BAG_CAPACITY: 50000,
  BARLEY_BAG_CAPACITY: 10000000,
  GRAIN_CORN: 'grain corn',
  POLAND_CODE: 'POL',
  POLAND: 'POLAND',
  ROMANIA: 'ROMANIA',
  HUNGARY: 'HUNGARY',
  ROMANIA_CODE: 'RO',
  ROMANIA_POSTAL_CODE: 'ROU',
  HUNGARY_CODE: 'HU',
  UKRAINE_CODE: 'UKR',
  BULGARIA_CODE: 'BGR',
  BRAZIL_CODE: 'BRZ',
  SOUTH_AFRICA_CODE: 'ZAF',
  WHEAT_SMALLCASE: 'wheat',
  SOUTH_AFRICA: 'South Africa',
  Brazil: 'Brazil',
  Bulgaria: 'Bulgaria',
  BULGARIA_ISO2: 'BG',
  SOYBEAN_SMALLCASE: 'soybean',
  SOYBEANS: 'Soybeans',
  WINTER_CORN: 'Winter Corn',
  SUMMER_CORN: 'Summer Corn',
  ENGLAND_CODE: 'GBR',
  NETHERLANDS_CODE: 'NLD',
  NETHERLANDS_BAG_SIZE: 50000,
  FRANCE: 'France',
  FRANCE_CODE: 'FRA',
  SERBIA: 'Serbia',
  SAFRA: 'Safra',
  SAFRINA: 'Safrina',
};

// Country name to Alpha2 code mapping
export const COUNTRY_NAME_TO_ALPHA2: Record<string, string> = {
  Belarus: 'by',
  Belgium: 'be',
  Brazil: 'br',
  Bulgaria: 'bg',
  'Czech Republic': 'cz',
  France: 'fr',
  Germany: 'de',
  Hungary: 'hu',
  Italy: 'it',
  Kazakhstan: 'kz',
  Moldova: 'md',
  Netherlands: 'nl',
  Poland: 'pl',
  Portugal: 'pt',
  Romania: 'ro',
  'Russian Federation': 'ru',
  Serbia: 'rs',
  Slovakia: 'sk',
  'South Africa': 'za',
  Spain: 'es',
  Switzerland: 'ch',
  Turkey: 'tr',
  Ukraine: 'ua',
  'United Kingdom': 'gb',
};

// List of crops needs to excluded like Winter Oilseed Rape crop
export const ExcludedCropList = [CropConstants.WINTER_OILSEED_RAPE];

const harvestDateConstants = [
  {
    countryCode: 'POL',
    date: '1 Oct',
  },
  {
    countryCode: 'ROU',
    date: '1 Sep',
  },
  {
    countryCode: 'HUN',
    date: '1 Oct',
  },
];
export const sunflowerEnabledCountries = ['ROU', 'HUN'];

export const getHarvestDate = (countryCode: string | undefined): string => {
  return (
    harvestDateConstants.find((data) => data.countryCode === countryCode)?.date ??
    harvestDateConstants[0].date
  );
};

export const countriesWithCornCrop = [
  CropConstants.POLAND_CODE,
  CropConstants.BULGARIA_CODE,
  CropConstants.UKRAINE_CODE,
  CropConstants.ROMANIA_POSTAL_CODE,
];

export const tppZoneInSouthAfrica = 'Free State,North West and KwaZulu-Natal-';

export const southAfricaCropwiseMailId = 'cropwise.za@syngenta.com';

export const growthStageCrops = ['silage corn', 'summer corn', 'grain corn', 'corn', 'sunflower'];

export const cropWithOutFao = ['wheat', 'barley'];
export const dassatSupportedCropsAndCountry = {
  corn: [
    'AT',
    'BE',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IT',
    'PL',
    'NL',
    'ES',
    'SE',
    'CH',
    'RO',
    'BG',
    'SK',
    'HR',
    'RS',
    'RU',
    'UA',
    'SI',
    'AR',
    'UY',
    'BR',
    'PY',
    'US',
    'CA',
  ],
  sunflower: [
    'AT',
    'BE',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IT',
    'PL',
    'NL',
    'ES',
    'SE',
    'CH',
    'RO',
    'BG',
    'SK',
    'HR',
    'RS',
    'RU',
    'UA',
    'SI',
    'AR',
    'UY',
  ],
  soybean: ['AR', 'UY', 'BR', 'PY', 'US', 'CA'],
  wheat: [
    'AT',
    'BE',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IT',
    'PL',
    'NL',
    'ES',
    'SE',
    'CH',
    'RO',
    'BG',
    'SK',
    'HR',
    'RS',
    'SI',
    'AR',
    'UY',
    'CA',
  ],
  barley: [
    'AT',
    'BE',
    'CZ',
    'DK',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IT',
    'PL',
    'NL',
    'ES',
    'SE',
    'CH',
    'RO',
    'BG',
    'SK',
    'HR',
    'GB',
    'RS',
  ],
};

type SupportedCrop = keyof typeof dassatSupportedCropsAndCountry;

export const isDssatSupported = (cropName: string, countryCode: string) => {
  let crop = cropName.toLowerCase() as SupportedCrop;
  if (cropName.toLowerCase().includes('corn')) {
    crop = 'corn' as SupportedCrop;
  }
  const country = countryCode.toUpperCase();
  return dassatSupportedCropsAndCountry[crop]?.includes(country) || false;
};
